import React from "react";
import Link from "next/link";

/**
 *
 */
export type LabelData = {
    id : string
    name : string
    translation : string
    hierarchy : number
};

/**
 *
 */
type Data = {
    label : LabelData
};

/**
 *
 * @param label
 * @constructor
 */
export default function Label ({ label } : Data) {
    // render
    return (
        <Link href={'/product/search?label=' + label.id} className="text-decoration-none d-inline badge rounded-pill bg-secondary me-2 mb-2">
            {label.translation}
        </Link>
    );
}